const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.8009 8.8691C13.6787 8.99371 13.6103 9.16126 13.6103 9.33576C13.6103 9.51026 13.6787 9.67781 13.8009 9.80243L14.8675 10.8691C14.9922 10.9912 15.1597 11.0597 15.3342 11.0597C15.5087 11.0597 15.6763 10.9912 15.8009 10.8691L18.3142 8.35576C18.6494 9.09655 18.7509 9.92192 18.6052 10.7219C18.4594 11.5218 18.0734 12.2583 17.4984 12.8333C16.9234 13.4082 16.1869 13.7943 15.387 13.9401C14.587 14.0858 13.7617 13.9843 13.0209 13.6491L8.41421 18.2558C8.149 18.521 7.78929 18.67 7.41421 18.67C7.03914 18.67 6.67943 18.521 6.41421 18.2558C6.149 17.9905 6 17.6308 6 17.2558C6 16.8807 6.149 16.521 6.41421 16.2558L11.0209 11.6491C10.6857 10.9083 10.5842 10.0829 10.7299 9.283C10.8757 8.48306 11.2617 7.74653 11.8367 7.17158C12.4117 6.59662 13.1482 6.21054 13.9481 6.06479C14.7481 5.91904 15.5734 6.02054 16.3142 6.35576L13.8075 8.86243L13.8009 8.8691Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaService);
export default __webpack_public_path__ + "static/media/ha-service.f897f0c914916f2feddc772add41912a.svg";
export { ForwardRef as ReactComponent };